export default __webpack_public_path__ + "static/media/IconTooltipImportant.11e962a2.svg";